module.exports = __webpack_public_path__ + "static/media/logo-initial-letter.c9b02a56.svg";